/*  Author: Luís Mourão / Felipe Pegado
    Type: Smart
	Description: 
    TODO: 
    - Criar componente dumb grid com o conteúdo do return(render)
    - Colocar mesma lógica do Current para Dropdown de Rotas e Referências
*/

import React, { Component } from 'react'
import { Dropdown, Icon, Grid, Input, Popup, Label } from 'semantic-ui-react'
import getSafe from 'Utils/getSafe.js'
import fitBounds from 'Utils/fitBounds.js'
import { changeLoginPreferences } from 'Store/actions/login-action'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { setTrue, setFalse } from 'Store/actions/toggle-action'
import { innerPosition } from 'Components/Map/InnerMap/innerPosition'
import styled from 'styled-components'
import { setCurrentModule } from 'Store/actions/modules-action'
import MapMethods from 'Utils/components/MapMethods'
import { debounce } from 'throttle-debounce'
import { regExpEscape } from 'Utils/escape'

const DropdownStyled = styled(Dropdown)`
  color: #4b72b2;
`
const DropdownMenu = styled(Dropdown.Menu)`
  border-top-width: 0px !important;
`
const DropdownGridInput = styled(Grid)`
  width: 217px;
  padding-left: 10px;
`
const DropdownGridHeader = styled(Grid)`
  width: 217px;
  padding-left: 10px;
  margin: 0px !important;
`
const DropdownHeader = styled(Dropdown.Header)`
  font-size: 1.33em;
  font-weight: 800;
`
const DropdownGridItem = styled(Grid)`
  width: 400px;
`
const DropdownGridName = styled(Grid.Column)`
  padding: 10px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 14px;
  padding-right: 0;
`

const ItemEyeGrid = styled(Grid.Column)`
  padding: 10px !important;
`
const DropdownInputGrid = styled(Grid.Column)``
const DropdownDivider = styled(Dropdown.Divider)`
  margin-bottom: 10px !important;
  margin-left: 8px !important;
  margin-right: 8px !important;
`

class DropdownFences extends Component {
  constructor(props) {
    super(props)
    this.state = {
      Área: false,
      Equipamento: false,
      fences: false,
      fitBounds: null,
      searchValue: '',
      open: false,
    }
    this.debounceCurrent = debounce(300, this.menuItemHover)
  }

  componentWillUnmount() {
    this.handleBlur()
  }

  itemClick(id, type) {
    let coords = getSafe(() => this.props[type].byId[id].info.geometry.coordinates, null)
    let radius = getSafe(() => this.props[type].byId[id].info.geometry.mRadius, null)
    this.props.setCurrentModule(id, type)
    if (coords) {
      if (this.props.inner) coords = innerPosition(coords, 'coordinates')
      if (!radius) fitBounds(type, coords, this.props.refMap)
      else this.setState({ fitBounds: { type, coords, radius } })
    }
  }

  iconClick(id, invisible) {
    this.props.changeLoginPreferences({ field: 'fences', preferences: { [id]: { id, invisible } } })
  }

  handleBlur = () => {
    this.props.setCurrentModule(null, 'fences')
    this.setState({ open: false })
  }

  headerIconClick(all, type) {
    const status = !this.state[type]
    let newState = {}
    let preferences = {}
    if (Array.isArray(all) && all.length > 0) {
      all.forEach((e) => {
        const invisible = this.props.fencesPreferences[e.id]?.invisible || false
        if (this.state[type] === invisible) {
          preferences[e.id] = {
            id: e.id,
            invisible: status,
          }
        }
      })
    }

    newState['fences'] = status
    if (type === 'fences') {
      newState['Área'] = status
      newState['Equipamento'] = status
    } else {
      newState[type] = status
    }

    if (preferences) {
      this.props.changeLoginPreferences({ field: 'fences', preferences })
    }

    this.setState({ ...newState })
  }

  menuItemHover = (id, type) => {
    this.props.setCurrentModule(id, type)
  }

  handleSearch = (event, data) => {
    this.setState({ searchValue: data.value })
  }

  render() {
    const { fences, perfil, t, empresa } = this.props
    const { searchValue } = this.state
    const spaceTypes = [
      { icon: 'shield', name: 'Área' },
      { icon: 'configure', name: 'Equipamento' },
    ]

    const sortMapFences = (par) => {
      if (Array.isArray(par) && par.length > 0) {
        let res = []
        spaceTypes.forEach((spaceType, j, allST) => {
          par
            .filter((fence) => getSafe(() => fence.info.properties.spaceType === spaceType.name, false))
            .sort((prev, next) => prev.info.properties.label.localeCompare(next.info.properties.label))
            .forEach((e, i, all) => {
              const invisible = this.props.fencesPreferences[e.id]?.invisible || false
              if (!i)
                res.push(
                  <DropdownGridHeader className="header" key={spaceType.name}>
                    <DropdownGridName width={14}>
                      <DropdownHeader key={spaceType.name} icon={spaceType.icon} content={t(spaceType.name)} />
                    </DropdownGridName>
                  </DropdownGridHeader>
                )
              res.push(
                <Dropdown.Item value={e.id} key={spaceType.name + e.id}>
                  <DropdownGridItem id="DropdownGridItem" onMouseEnter={() => this.debounceCurrent(e.id, 'fences')}>
                    <DropdownGridName
                      onClick={() => this.itemClick(e.id, 'fences')}
                      width={14}
                      title={e.info.properties.label}
                    >
                      {e.info.properties.label}
                    </DropdownGridName>
                    <ItemEyeGrid width={2} textAlign="right" style={{ left: '2px' }}>
                      <Icon
                        onClick={() => this.iconClick(e.id, !invisible)}
                        name={invisible ? 'eye slash' : 'eye'}
                        title={invisible ? t('EyesShow') : t('EyesHide')}
                        size="small"
                      />
                    </ItemEyeGrid>
                  </DropdownGridItem>
                </Dropdown.Item>
              )
            })
          if (j + 1 < allST.length) res.push(<DropdownDivider key={'dpFencesDivEnd' + j} />)
        })

        return res
      } else return null
    }

    let fencesList = fences
      ? fences.allIds
          .filter((id) => getSafe(() => !fences.byId[id].info.properties.invisible, true) || perfil === 'DEV')
          .map((each) => fences.byId[each])
      : []
    let filtered = fencesList.filter(
      (data) =>
        data?.info?.properties?.label &&
        data.info.properties.label.search(new RegExp(regExpEscape(searchValue), 'i')) !== -1
    )
    return (
      <DropdownStyled
        trigger={
          <Popup
            trigger={<Icon name="th large" size="large" onClick={() => this.setState({ open: !this.state.open })} />}
            content={['TiplamTest', 'Tiplam', 'Phygitall'].includes(empresa) ? 'Perímetros' : t('DropdownMenuFences')}
            position="bottom center"
            size="tiny"
            inverted
          />
        }
        icon={null}
        pointing="top right"
        onBlur={this.handleBlur}
        style={{ pointerEvents: 'auto' }}
        open={this.state.open}
        disabled={fencesList.length ? false : true}
      >
        <Dropdown.Menu>
          <DropdownGridInput className="header">
            <DropdownInputGrid width={14}>
              <Input
                onChange={(e, d) => this.handleSearch(e, d)}
                icon
                iconPosition="left"
                placeholder={
                  ['TiplamTest', 'Tiplam', 'Phygitall'].includes(empresa)
                    ? 'Perímetros'
                    : t('DropdownMenuFences') + '...'
                }
                size="large"
                style={{ width: '150px' }}
              >
                <Icon name="square" />
                <input />
              </Input>
            </DropdownInputGrid>
            <ItemEyeGrid width={2} textAlign="right" floated="right" style={{ bottom: '1px' }}>
              <Label size="mini" style={{ marginLeft: '42px', marginTop: '-8px' }}>
                <Icon
                  onClick={() => this.headerIconClick(filtered, 'fences')}
                  name={this.state.fences ? 'eye slash' : 'eye'}
                  size="small"
                  title={this.state.fences ? t('EyesAllShow') : t('EyesAllHide')}
                  style={{ fontSize: '1.50em', cursor: 'pointer' }}
                />
                <Label.Detail>
                  <span style={{ fontSize: '1.9em' }}> {this.state.fences ? t('EyesAllShow') : t('EyesAllHide')}</span>
                </Label.Detail>
              </Label>
            </ItemEyeGrid>
          </DropdownGridInput>
          <DropdownDivider />
          <DropdownMenu scrolling>
            {filtered.length > 0 ? sortMapFences(filtered) : <Dropdown.Item text={t('NoFences')} disabled />}
          </DropdownMenu>
          {this.state.fitBounds && (
            <MapMethods type="circle" fit={this.state.fitBounds} cb={() => this.setState({ fitBounds: null })} />
          )}
        </Dropdown.Menu>
      </DropdownStyled>
    )
  }
}

const mapStateToProps = (state) => ({
  inner: state.toggle.showInnerMap,
  fences: state.modules.fences,
  empresa: state.login.empresa,
  fencesPreferences: state.login.preferences.fences,
})

const mapDispatchToProps = {
  setTrue: setTrue,
  setFalse: setFalse,
  setCurrentModule: setCurrentModule,
  changeLoginPreferences,
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(DropdownFences))
